module.exports = __webpack_public_path__ + "static/media/card-block.247c6446.svg";